<template>
    <div class="check">
        <van-checkbox-group v-model="result">
            <div class="list" v-for="(item,index) in list" :key="index">
                <div>{{ item.label }}</div>
                <div>
                    <van-checkbox :name=item.value></van-checkbox>
                </div>
            </div>
        </van-checkbox-group>
    </div>
</template>
<script>
export default {
    name:'',
    data() {
        return {
            list:[],
            result:[]
        }
    },
}
</script>
<style lang="less" scoped>
</style>